import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  commentContainer: {
    marginBottom: theme.spacing(4),
  },
  userContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(1, 0),
    gap: theme.spacing(4),
  },
  createdAt: {
    fontSize: "12px",
    color: theme.palette.primary.light,
  },
  imagePreview: {
    width: "25px",
    height: "25px",
    objectFit: "contain",
    borderRadius: "5px",
    marginLeft: theme.spacing(1),
    cursor: "pointer",
  },
  text: {
    hyphens: "auto",
    fontSize: "14px",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    margin: theme.spacing(1, 0),
    padding: `0 ${theme.spacing(1)}`,
    lineHeight: 1.5,
    textAlign: "left",
  },
  actionsContainer: {
    display: "flex",
    gap: theme.spacing(3),
    justifyContent: "flex-start",
    margin: theme.spacing(1, 0),
  },
  actionButton: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    padding: theme.spacing(1, 1),
    marginLeft: theme.spacing(2),
    fontSize: "16px",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    cursor: "pointer",
    border: "none",
    transition: "background-color 0.3s, transform 0.3s",
    "&:hover": {
      backgroundColor: theme.palette.primary.contrastText,
      transform: "scale(1.2)",
    },
  },
  replyComments: {
    marginLeft: theme.spacing(4),
    paddingTop: theme.spacing(2),
  },
  toggleRepliesButton: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  previewContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
    maxWidth: "40%",
    borderLeft: "4px solid #ccc",
    paddingLeft: theme.spacing(2),
  },
  previewImage: {
    width: "160px",
    height: "90px",
    objectFit: "cover",
    borderRadius: theme.shape.borderRadius,
  },
  previewTitle: {
    fontWeight: "bold",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    maxWidth: "100%",
  },
  previewDescription: {
    color: theme.palette.text.secondary,
    maxWidth: "100%",
    fontSize: "0.8em",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  previewTitleLink: {
    color: "#0070f3",
    textDecoration: "none",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "color 0.3s ease",
    "&:hover, &:focus": {
      color: "#0056b3",
      textDecoration: "underline",
    },
  },
}));
